import useRequestState from './useRequestState'
import { useChatState } from '../state/ChatState'
import orchestration from '../api/orchestration'

export default function useSearchForChatRoom() {
  const { connection } = useChatState()
  const results = useRequestState(async ({ searchStr, type = 'GENERAL', matchExactly = false, limit }) => {
    if (searchStr?.trim().length > 1) {
      if (matchExactly) {
        return orchestration.chatgroups.searchForChatRoomByExactName({ searchStr, type }).then((res) => {
          return res.data
        })
      }
      return orchestration.chatgroups.searchForChatRoom({ searchStr, type, limit })
    }

    return Promise.resolve(null)
  })
  return connection ? results : []
}
